<template>
  <Page title="Contract Addresses">
    <v-row no-gutters justify="center" class="mb-16" style="max-width: 100% !important">
      <v-col no-gutters>
        <div :class="[contentFont, spacing]" class="reflective-card">
          <h3 :class="sectionSubheadlineFont" class="my-3">BNB Smart Chain</h3>
          <a href="https://bscscan.com/token/0x8459AB8d6aa488716c568896c0502C0AF0EB6983" target="_blank">
            <div class="ca">0x8459AB8d6aa488716c568896c0502C0AF0EB6983</div>
          </a>
          <a class="highlight" @click="event => copyToClipboard(event, '0x8459AB8d6aa488716c568896c0502C0AF0EB6983')">
            <div class="ma-2">Copy</div>
          </a>

          <h3 :class="sectionSubheadlineFont" class="my-3">Injective</h3>
          <a href="https://explorer.injective.network/asset/factory%2Finj1khttezjv9x6dpadysffpf7m00rch2ldhezz7s2%2Ftix/" target="_blank">
            <div class="ca">factory/inj1khttezjv9x6dpadysffpf7m00rch2ldhezz7s2/tix</div>
          </a>
          <a class="highlight" @click="event => copyToClipboard(event, 'factory/inj1khttezjv9x6dpadysffpf7m00rch2ldhezz7s2/tix')">
            <div class="ma-2">Copy</div>
          </a>

          <h3 :class="sectionSubheadlineFont" class="my-3">MultiversX</h3>
          <a href="https://explorer.multiversx.com/tokens/TIX-338f11" target="_blank">
            <div class="ca">TIX-338f11</div>
          </a>
          <a class="highlight" @click="event => copyToClipboard(event, 'TIX-338f11')">
            <div class="ma-2">Copy</div>
          </a>
        </div>
      </v-col>
      <v-snackbar v-model="snackbar" timeout="2000">
        {{ snackbarMessage }}
        <template v-slot:action="{ attrs }">
          <v-btn color="#ff6200" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-row>
  </Page>
</template>

<script>
import Page from "../Page.vue";

export default {
  name: "CA",
  metaInfo: {
    title: "Contract Addresses"
  },
  components: { Page },
  props: [],
  data() {
    return {
      snackbar: false,
      snackbarMessage: "",
    };
  },
  computed: {
    contentFont() {
      switch (this.$vuetify.breakpoint.name) {
        case "xl":
        case "lg":
          return "poppins-normal-white-18px";
        case "md":
        case "sm":
          if (!this.$isMobile()) {
            return "poppins-normal-white-16px";
          } else {
            return "poppins-normal-white-15px";
          }
        case "xs":
          return "poppins-normal-white-15px";
      }
    },
    subtitleFont() {
      switch (this.$vuetify.breakpoint.name) {
        case "xl":
        case "lg":
          return "poppins-bold-white-42px";
        case "md":
        case "sm":
        case "xs":
          return "poppins-bold-white-24px";
      }
    },
    headlineFont() {
      switch (this.$vuetify.breakpoint.name) {
        case "xl":
        case "lg":
          return "poppins-bold-white-64px";
        case "md":
        case "sm":
        case "xs":
          return "poppins-bold-white-32px";
      }
    },
    sectionSubheadlineFont() {
      switch (this.$vuetify.breakpoint.name) {
        case "xl":
        case "lg":
        case "md":
          return "poppins-bold-white-26px";
        case "sm":
        case "xs":
          return "poppins-bold-white-20px";
      }
    },
    spacing() {
      switch (this.$vuetify.breakpoint.name) {
        case "xl":
        case "lg":
        case "md":
          return "spacing-desktop";
        case "sm":
        case "xs":
          return "spacing-mobile";
      }
    },
    xSpacing() {
      switch (this.$vuetify.breakpoint.name) {
        case "xl":
        case "lg":
        case "md":
          return "x-spacing-desktop";
        case "sm":
        case "xs":
          return "x-spacing-mobile";
      }
    },
  },
  methods: {
    copyToClipboard(event, address) {
      event.preventDefault();
      navigator.clipboard.writeText(address).then(() => {
        if (!this.$isMobile()) {
          this.snackbarMessage = `Copied ${address} to your clipboard`;
          this.snackbar = true;
        }
      }, () => {
        this.snackbarMessage = "Failed to copy to clipboard.";
        this.snackbar = true;
      });
    },
  },
};
</script>

<style scoped>
.priv-list {
  list-style-type: none;
}

.priv-list li:before {
 content: "\2022";
 padding-right: 0.5em;
 color: white;
}

.highlight {
  color: #B09EFF !important;
  font-weight: 600 !important;
}

.spacing-desktop {
  padding: 80px 160px;
  margin-bottom: 80px;
}

.spacing-mobile {
  padding: 20px;
  margin-bottom: 40px;
}

.spacing-last {
  margin-bottom: 0px !important;
}

.x-spacing-desktop {
  padding: 0px 160px;
  margin-bottom: 40px !important;
}

.x-spacing-mobile {
  padding: 0px 20px;
  margin-bottom: 20px !important;
}

* a {
  color: inherit !important;
  text-decoration: none !important;
}

.bold {
  font-weight: 700;
}

.ca {
  font-family: monospace;
  padding: 10px;
  border: thin solid white !important;
  border-radius: 10px;
  width: 100%;
  overflow-wrap: break-word;
}
</style>
